import React from 'react';
import './ContactUsBanner.css'; // Define styles similarly to AboutUsBanner.css

const ContactUsBanner = () => {
  return (
    <div className="contact-banner text-white d-flex align-items-center">
      <div className="container text-center">
        <h2 className="display-4 fw-bold mt-5">Contact Us</h2>
      </div>
    </div>
  );
};

export default ContactUsBanner;
